// core
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// services
import { ApiService } from '../services/api.service';

@Injectable({
  providedIn: 'root'
})
export class PolicyService extends ApiService {

  endorse(uuid: string): Promise<any> {
   return this.get(`/v2/policy/${uuid}/endorse`).toPromise();
  }

  prerenew(uuid: string): Promise<any> {
    return this.get(`/v2/policy/${uuid}/prerenew`).toPromise();
   }

  cancel(uuid: string): Promise<any> {
    return this.get(`/v2/policy/${uuid}/cancel`).toPromise();
  }

  downloadCoi(uuid: string): Observable<HttpResponse<Blob>> {
    return this.post(`/v2/policy/${uuid}/action/download_coi`, null, { observe: 'response', responseType: 'blob', withCredentials: true });
  }

  downloadCoc(uuid: string): Observable<HttpResponse<Blob>> {
    return this.post(`/v2/policy/${uuid}/action/download_coc`, null, { observe: 'response', responseType: 'blob', withCredentials: true });
  }

  downloadLegacyCoi(policyClass:string, uuid: string): Observable<HttpResponse<Blob>> {
    return this.get(`/policy/${policyClass}/download-coi/${uuid}`, { observe: 'response', responseType: 'blob', withCredentials: true });
  }

  downloadLegacyCoc(policyClass:string, uuid: string): Observable<HttpResponse<Blob>> {
    return this.get(`/policy/${policyClass}/download-coc/${uuid}`, { observe: 'response', responseType: 'blob', withCredentials: true });
  }

  updateRenewalFlag(policySlug: string, renewalFlag: 'CE' | 'CD'): Promise<any> {
    const payload = {
      policy_uuid: policySlug,
      renewal_flag: renewalFlag
    };
    return this.post(`/v2/policy/renewal_flag`, payload, { observe: 'response', responseType: 'blob', withCredentials: true }).toPromise();
  }

  getLegacyPolicyBySlug(productClass: string, policySlug: string): Promise<any> {
    return this.get(`/policy/${productClass}/${policySlug}`).toPromise();
  }

  getPolicyBySlug(policySlug:string): Promise<any> {
    return this.get(`/v2/policy/${policySlug}`).toPromise();
  }

  getOdoBySlug(policySlug: string): Promise<any> {
    return this.get(`/policy/car/odo/${policySlug}`).toPromise();
  }

  create(policySlug: string, reading: number): Promise<any> {
    const payload = { reading };

    return this.post(`/policy/car/odo/${policySlug}`, payload).toPromise();
  }

  updatePaymentByPolicySlug(uuid: string, payload: any) {
    return this.post(`/v2/policy/${uuid}/action/update_payment_method`, payload).toPromise();
  }

  retryPaymentByPolicySlug(uuid: string) {
    return this.post(`/policy/${uuid}/retry_payment`, null).toPromise();
  }

  updateLegacyPolicyBySlug(productClass: string, policySlug: string, payload: any): Promise<any> {
    return this.patch(`/policy/${productClass}/${policySlug}`, payload).toPromise();
  }

  /* Central APIs below this point */

  search(queryParamsString: string): Promise<any> {
    return this.get(`/v2/policy/supersearch${queryParamsString}`).toPromise();
  }

  searchByCustomer(productClass: string, customerSlug: string): Promise<any> {
    return this.get(`/admin/policy/${productClass}/by-user/${customerSlug}`).toPromise();
  }

  details(productClass: string, uuid: string): Promise<any> {
    return this.get(`/admin/policy/${productClass}/${uuid}`).toPromise();
  }

  resendCOI(productClass: string, policySlug: string, phaseSlug: string): Promise<any> {
    return this.post(`/admin/policy/${productClass}/resend-coi/${policySlug}/${phaseSlug}`, null).toPromise();
  }

  timeline(policySlug: string): Promise<any> {
    return this.get(`/v2/policy/timeline/${policySlug}`).toPromise();
  }

  saveOdometer(params: any): Promise<any> {
    return this.put(`/admin/policy/car/${params.policySlug}/odometer`, params).toPromise();
  }

  renewalFlag(productClass: string, policySlug: string, renewalFlag: string): Promise<any> {
    return this.post(`/admin/policy/${productClass}/renewal_flag/${policySlug}/${renewalFlag}`, null).toPromise();
  }
}
